/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the field to use for sorting the data:
 *   * NAME: The name of the role.
 *   * ROLE_TYPE: The type of the role.
 */
export enum RolesSortFieldName {
  NAME = 'NAME',
  ROLE_TYPE = 'ROLE_TYPE'
}
